import styled from 'styled-components';

export const Description = styled.p`
  margin: 0;
  font-size: 12px;
  font-weight: 400;
  color: #595959;
`;

export const Actions = styled.div`
  margin: 0 -16px;
`;

export const Action = styled.button`
  display: flex;
  gap: 12px;
  align-items: center;
  width: 100%;
  min-height: 60px;
  padding: 0 16px;
  font: inherit;
  color: #262626;
  text-align: left;
  cursor: pointer;
  background: none;
  border: none;
  border-top: 1px solid #f0f0f0;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const ActionIcon = styled.span`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  font-size: 18px;
  color: #d16d0f;
  background: #fff4e6;
  border-radius: 2px;

  &[data-tone='success'] {
    color: #389e0d;
    background: #f6ffed;
  }
`;

export const ActionText = styled.span`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
`;

export const ActionHint = styled.span`
  font-size: 12px;
  color: #595959;
`;

export const CancelButton = styled.button`
  width: 100%;
  height: 44px;
  font: inherit;
  font-weight: 500;
  color: #262626;
  cursor: pointer;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 2px;
`;
